module.exports = require("@fingerprintjs/fingerprintjs-pro");